import { LayoutDashboard, Calendar, Utensils, Target, PartyPopper, BookUser, ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";

const navItems = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "calendar", label: "Calendar", icon: Calendar },
  { id: "contacts", label: "Targets", icon: Target },
  { id: "events", label: "Events", icon: PartyPopper },
  { id: "catering", label: "Catering", icon: Utensils },
  { id: "vendors", label: "Vendors", icon: BookUser },
];

export function DashboardSidebar({ activeTab, onTabChange }) {
  return (
    <aside className="w-full h-full bg-muted/30 border-r p-4 flex flex-col gap-6">
      <nav className="flex flex-col gap-1 flex-1">
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2 px-2">
          Navigation
        </p>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => onTabChange(item.id)}
              className={cn(
                "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors text-left w-full",
                isActive
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
            >
              <Icon className="h-4 w-4 shrink-0" />
              <span className="truncate">{item.label}</span>
            </button>
          );
        })}
        <div className="mt-auto pt-4 border-t border-border">
          <a
            href="https://portal.kahalamgmt.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-kahala"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors text-left w-full text-muted-foreground hover:bg-muted hover:text-foreground"
          >
            <ExternalLink className="h-4 w-4 shrink-0" />
            <span className="truncate">Kahala Portal</span>
          </a>
        </div>
      </nav>
    </aside>
  );
}
